export default "__VITE_ASSET__DrrpymYZ__"